// extracted by mini-css-extract-plugin
export default {"EledoTemplateRoot":"EledoTemplateRoot_EledoTemplateRoot__j17cN","content-wrapper":"EledoTemplateRoot_content-wrapper__r3EXi"};